/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, ReactNode } from "react";
import { useLogoutMutation } from "shared/api";

interface AutoLogoutProviderProps {
  children: ReactNode;
}

const AutoLogoutProvider: React.FC<AutoLogoutProviderProps> = ({
  children,
}) => {
  const [logout] = useLogoutMutation();

  const checkLogout = async () => {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Europe/Berlin",
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

    const timeString = new Intl.DateTimeFormat("en-GB", options).format(now);
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    const isMorningLogout = hours === 6 && minutes === 0 && seconds === 0;
    const isEveningLogout = hours === 18 && minutes === 0 && seconds === 0;

    if (isMorningLogout || isEveningLogout) {
      try {
        await logout().unwrap();
      } catch (err) {
        /* eslint-disable no-console */
        console.error("Auto logout failed:", err);
      }
    }
  };

  useEffect(() => {
    const interval = setInterval(checkLogout, 1000);

    return () => clearInterval(interval);
  }, [logout]);

  return <>{children}</>;
};

export default AutoLogoutProvider;
